import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { EducationProgramDTO } from '@core/apis/education/education.dto';
import { BookingStorageEnum } from '@core/enums/booking.enum';
import { IBookingStorageDeleteEvent } from '@core/interfaces/booking.interface';
import { FormatTimePipe } from '@core/pipes/format-time.pipe';
import { TranslocoModule } from '@jsverse/transloco';
import { ProductCardComponent } from '../product-card/product-card.component';

@Component({
  selector: 'app-education-view',
  imports: [
    CommonModule,
    TranslocoModule,
    FormatTimePipe,
    ProductCardComponent,
  ],
  standalone: true,
  templateUrl: './education-view.component.html',
  styleUrl: './education-view.component.scss',
})
export class EducationViewComponent {
  @Input({ required: true }) public program!: EducationProgramDTO;
  @Output('delete') public delete: EventEmitter<IBookingStorageDeleteEvent> =
    new EventEmitter();

  public teamPath: string = '';
  public readonly BookingStorageEnum = BookingStorageEnum;

  public ngOnInit(): void {
    this.teamPath = `educational/${this.program.id}`;
  }
}
